import React from 'react';
import { I18n } from '@fiverr-private/fiverr_context';
import { buildBusinessPrioritisedKey } from '../../../../../../shared/utils/translation';
import { ViewTab } from '../../constants';

const ROOT = 'collections_perseus.collection_page.tabs';

export const getTabs = ({ isBusiness, gigsTotal, sellersTotal }) => {
    const gigsTitleKey = buildBusinessPrioritisedKey(ROOT, isBusiness, 'gigs');
    const sellersTitleKey = buildBusinessPrioritisedKey(ROOT, isBusiness, 'sellers');

    return [
        {
            name: ViewTab.GIGS,
            title: <I18n k={gigsTitleKey} params={{ total: gigsTotal }} />,
        },
        {
            name: ViewTab.SELLERS,
            title: <I18n k={sellersTitleKey} params={{ total: sellersTotal }} />,
        },
    ];
};
